<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add State Holiday
          <v-progress-circular
            v-if="isMasterLoading"
            class="ml-5"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
               <v-autocomplete
                ref="state"
                outlined
                v-model="form.state"
                :items="stateItems"
                label="State *"
                hint="State for which this holiday is applicable"
                clearable
                :error-messages="errors.state"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                  v-model="holidayDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.holiday_date"
                        label="Holiday Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        hide-details="auto"
                        clearable
                        @click:clear="(form.holiday_date = null), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.holiday_date"
                      @input="holidayDateMenu = false, getData()"
                    ></v-date-picker>
                  </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.description"
                outlined
                label="Description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'state_holidays'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save State Holiday
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StateHolidayCreatePage",
  data() {
    return {
      form: {
        state: "",
        holiday_date: "",
        description: "",
        is_recurring: 0,
      },
      stateItems: [],
      isLoading: false,
      isMasterLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    Final_amount_hint() {
      let text = "Final Discounted Amount";
      if (this.form.no_of_dogs > 1 && this.form.no_of_walks > 1) {
        text ==
          "1st Dog Fee :" +
            this.form.calculated_final_amount +
            " + Second Dog/walk : " +
            this.form.second_discount_amount;
      }
      return text;
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=state_holidays`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.description,
              value: state.description,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
    },
    calculate(type = "") {
      this.isCalculating = true;
      let original_amount = this.form.original_amount;
      let price_percent = this.form.price_percent;
      let discount_percent = this.form.discount_percent;
      if (original_amount) {
        if (type == "PRICE PERCENT CHANGE" && price_percent) {
          this.form.discount_percent = 100 - parseInt(price_percent);
        } else if (type == "DISCOUNT PERCENT CHANGE" && discount_percent) {
          this.form.price_percent = 100 - parseInt(discount_percent);
        } else {
          this.form.price_percent = parseInt(price_percent)
            ? parseInt(price_percent)
            : 0;
          this.form.discount_percent = parseInt(discount_percent)
            ? parseInt(discount_percent)
            : 0;
          console.log("BLANK");
        }
        this.CalculateFinalAmount();
      }
      if (type == "FINAL AMOUNT CHANGE" || type == "DAY CHANGE") {
        this.CalculatePerDayAmount();
        this.CalculateCommission();
      }
      console.log(this.form);
      this.isCalculating = false;
    },
    CalculateSecondDiscountAmount() {
      let calculated_final_amount = this.form.calculated_final_amount;
      console.log(calculated_final_amount);

      let second_discount_amount = 0;
      // let final_discount_amount = 0;
      if (calculated_final_amount) {
        second_discount_amount =
          calculated_final_amount -
          parseInt(
            parseFloat(
              parseFloat(calculated_final_amount) *
                parseFloat(this.form.second_discount_percent)
            ) / 100
          );
      }
      console.log(second_discount_amount);
      this.form.second_discount_amount = second_discount_amount;
      this.form.final_amount =
        parseInt(calculated_final_amount) + parseInt(second_discount_amount);
      this.CalculateCommission();
    },
    CalculateFinalAmount() {
      let calculated_final_amount = 0;
      if (this.form.original_amount && this.form.price_percent) {
        calculated_final_amount =
          parseFloat(
            parseFloat(this.form.original_amount) *
              parseFloat(this.form.price_percent)
          ) / 100;
      }
      this.form.calculated_final_amount = calculated_final_amount;
    },
    CalculatePerDayAmount() {
      let customer_per_day_charges = 0;
      console.log(this.form.final_amount);
      console.log(this.form.days);

      if (this.form.final_amount && this.form.days) {
        customer_per_day_charges = Math.ceil(
          parseFloat(this.form.final_amount) / parseInt(this.form.days)
        );
        console.log(customer_per_day_charges);
      }
      this.form.customer_per_day_charges = customer_per_day_charges;
    },
    CalculateCommission(type = "") {
      let company_percent = this.form.company_percent;
      let walkie_percent = this.form.walkie_percent;
      let franchisee_percent = this.form.franchisee_percent;
      company_percent = 100 - franchisee_percent - walkie_percent;
      console.log("Calculate Commission");

      if (type == "WALKIE PERCENT CHANGE") {
        console.log("Calculate Walkie Commission");
        franchisee_percent = 100 - company_percent - walkie_percent;
      } else if (type == "FRANCHISEE PERCENT CHANGE") {
        console.log("Calculate Franchisee Commission");
        walkie_percent = 100 - company_percent - franchisee_percent;
      } else {
        company_percent = 100 - walkie_percent - franchisee_percent;
      }
      this.form.franchisee_percent = franchisee_percent;
      this.form.walkie_percent = walkie_percent;
      this.form.company_percent = company_percent;
      this.CalculateWalkieAmount();
      this.CalculateFranchiseeAmount();
      this.CalculateCompanyAmount();
    },
    CalculateWalkieAmount() {
      let walkie_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        walkie_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.walkie_percent)
          ) / 100
        );
        console.log("Walkie Amount Updated : " + walkie_commission_amount);
      }
      this.form.walkie_commission_amount = walkie_commission_amount;
    },
    CalculateFranchiseeAmount() {
      let franchisee_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        franchisee_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.franchisee_percent)
          ) / 100
        );
        console.log(
          "Franchisee Amount Updated : " + franchisee_commission_amount
        );
      }
      this.form.franchisee_commission_amount = franchisee_commission_amount;
    },
    CalculateCompanyAmount() {
      let company_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        company_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.company_percent)
          ) / 100
        );
        console.log("Company Amount Updated : " + company_commission_amount);
      }
      this.form.company_commission_amount = company_commission_amount;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .post("/state_holidays", this.form)
          .then(async () => {
            await this.saveUserTimestamp(null, this.form);
            this.isLoading = false;
            this.$router.push("/state_holidays");
          })
          .catch((error) => {
            console.error(error);
            this.isUnAuthorised();
          });
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
